<template>
  <div>
    <v-row>
      <v-col md="6">
        <AccountPlanSelect
          v-model="searchParams.account_plan_id"
          :item-value="(val) => val.id"
          :dense="false"
          flat
          outlined
          multiple
          clearable
          @change="select(1)"
        />
      </v-col>
      <v-col md="6">
        <AccountMultiSelect
          v-model="searchParams.accounts"
          flat
          :dense="false"
          outlined
          multiple
          :item-value="(val) => val.id"
          clearable
          @change="select(1)"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col md="6">
        <OriginSelect
          v-model="searchParams.origin"
          flat
          outlined
          :item-value="(val) => val.code"
          multiple
          clearable
          @change="select(1)"
        />
      </v-col>
      <v-col md="6">
        <PaymentMethodSelect
          v-model="searchParams.payments_method"
          flat
          outlined
          multiple
          :item-value="(val) => val.code"
          clearable
          @change="select(1)"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          outlined
          v-model="searchParams.date_start"
          label="Vencimento Inicial"
          @change="select(1)"
        />
      </v-col>
      <v-col md="3">
        <v-text-field
          hide-details="auto"
          type="date"
          solo
          flat
          outlined
          v-model="searchParams.date_end"
          label="Vencimento Final"
          @change="select(1)"
        />
      </v-col>
      <v-col>
        <v-btn color="primary" class="mr-6" outlined x-large @click="select(1)">
          Pesquisar
        </v-btn>
        <v-btn
          color="warning"
          outlined
          x-large
          @click="handleClearData(), select(1)"
        >
          Limpar Data
        </v-btn>
      </v-col>
    </v-row>
    <v-row dense>
      <GroupedDataTable
        title="Agrupado por plano de contas"
        :headers="headers_accounts_plan"
        :items="groupedByAccountsPlan"
        :page.sync="searchParams.groupedByAccountsPlanPage"
        sectionKey="groupedByAccountsPlanPage"
        @page-change="select"
      />

      <GroupedDataTable
        title="Agrupado por caixa"
        :headers="headers_accounts"
        :items="groupedByAccounts"
        :page.sync="searchParams.groupedByAccountspage"
        sectionKey="groupedByAccountspage"
        @page-change="select"
      />

      <GroupedDataTable
        title="Agrupado por origem"
        :headers="headers_origin"
        :items="groupedByOrigin"
        :page.sync="searchParams.groupedByOriginPage"
        sectionKey="groupedByOriginPage"
        @page-change="select"
      />

      <GroupedDataTable
        title="Agrupado por método de pagamento"
        :headers="headers_payments_method"
        :items="groupedByPaymentsMethod"
        :page.sync="searchParams.groupedByPaymentsMethod"
        sectionKey="groupedByPaymentsMethod"
        @page-change="select"
      />
    </v-row>

    <v-row>
      <v-col md="12">
        <cash-flow-list
          :loading="loading"
          :accountTransactions="accountTransactions"
        />
      </v-col>
    </v-row>

    <v-pagination
      v-model="searchParams.page"
      :length="accountTransactions.last_page"
      @input="select($event)"
      :total-visible="9"
    />
  </div>
</template>

<script>
import AccountPlanSelect from "@/components/account-plan/ui/AccountPlanSelect.vue";
import CompanySelect from "@/components/company/ui/CompanySelect.vue";
import CashFlowList from "@/components/cash-flow/lists/CashFlowList.vue";
import CashFlowFilter from "@/components/cash-flow/filter/CashFlowFilter.vue";
import OriginSelect from "@/components/cash-flow-dashboard-selects/OriginSelect.vue";
import PaymentMethodSelect from "@/components/cash-flow-dashboard-selects/PaymentMethodSelect.vue";
import AccountMultiSelect from "@/components/account/ui/AccountMultiSelect.vue";
import GroupedDataTable from "@/components/grouped-data-table/GroupedDataTable.vue";

export default {
  components: {
    AccountPlanSelect,
    CompanySelect,
    CashFlowList,
    CashFlowFilter,
    AccountMultiSelect,
    OriginSelect,
    PaymentMethodSelect,
    GroupedDataTable,
  },

  data() {
    return {
      // Headers das tabelas agrupadas
      headers_accounts_plan: [
        { text: "Plano de Contas", value: "group" },
        { text: "Total", value: "total" },
      ],
      headers_accounts: [
        { text: "Caixa", value: "group" },
        { text: "Total", value: "total" },
      ],
      headers_origin: [
        { text: "Origem", value: "group" },
        { text: "Total", value: "total" },
      ],
      headers_payments_method: [
        { text: "Método de Pagamento", value: "group" },
        { text: "Total", value: "total" },
      ],

      // Dados agrupados por categoria
      groupedByAccountsPlan: { data: [], last_page: 1 },
      groupedByAccounts: { data: [], last_page: 1 },
      groupedByOrigin: { data: [], last_page: 1 },
      groupedByPaymentsMethod: { data: [], last_page: 1 },

      // Filtros e paginações
      searchParams: {
        account_plan_id: [],
        accounts: [],
        origin: [],
        payments_method: [],
        date_start: null,
        date_end: null,

        //paginações
        page: 1,
        groupedByAccountsPlanPage: 1,
        groupedByAccountspage: 1,
        groupedByOriginPage: 1,
        groupedByPaymentsMethod: 1,
      },

      // Transações principais
      accountTransactions: {
        data: [],
        last_page: 1,
        current_page: 1,
      },

      // Estado de carregamento
      loading: false,
    };
  },

  async mounted() {
    await this.select();
  },
  methods: {
    // Limpa as datas dos filtros
    handleClearData() {
      this.searchParams.date_end = null;
      this.searchParams.date_start = null;
    },

    // Requisição principal e agrupamentos com paginação separada
    async select(page = 1, sectionKey = "page") {
      this.searchParams[sectionKey] = page;

      const groupParams = {
        ...this.searchParams,
        page_account_plan: this.searchParams.groupedByAccountsPlanPage,
        page_account: this.searchParams.groupedByAccountspage,
        page_origin: this.searchParams.groupedByOriginPage,
        page_payment_method: this.searchParams.groupedByPaymentsMethod,
      };

      try {
        this.loading = true;

        const [cashFlowResponse, groupCashFlowResponse] = await Promise.all([
          this.$http.index("/account/cash-flow-dashboard", {
            ...this.searchParams,
            page: this.searchParams.page,
          }),
          this.$http.index("/account/group-cash-flow-dashboard", groupParams),
        ]);

        // Atribui os dados recebidos
        this.accountTransactions = cashFlowResponse;
        this.groupedByAccountsPlan = groupCashFlowResponse.by_account_plan;
        this.groupedByAccounts = groupCashFlowResponse.by_account;
        this.groupedByOrigin = groupCashFlowResponse.by_origin;
        this.groupedByPaymentsMethod = groupCashFlowResponse.by_payment_method;
        
      } catch (error) {
        console.error("Erro ao carregar dados:", error);
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>
